export { default as Img200 } from './processed/200/BANISHED_S01.jpg';
export { default as Img400 } from './processed/400/BANISHED_S01.jpg';
export { default as Imgthumb } from './processed/thumb/BANISHED_S01.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/BANISHED_S01.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/BANISHED_S01.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      189,
      145,
      90
    ],
    "_population": 1956,
    "_hsl": [
      0.09259259259259257,
      0.42857142857142866,
      0.5470588235294118
    ]
  },
  "LightVibrant": {
    "_rgb": [
      223,
      195,
      145
    ],
    "_population": 2184,
    "_hsl": [
      0.1068376068376068,
      0.5492957746478874,
      0.7215686274509804
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      82,
      34,
      10
    ],
    "_population": 13,
    "_hsl": [
      0.05555555555555555,
      0.7826086956521738,
      0.18039215686274512
    ]
  },
  "Muted": {
    "_rgb": [
      157,
      113,
      83
    ],
    "_population": 2248,
    "_hsl": [
      0.06756756756756754,
      0.30833333333333335,
      0.47058823529411764
    ]
  },
  "LightMuted": {
    "_rgb": [
      222,
      214,
      191
    ],
    "_population": 1919,
    "_hsl": [
      0.12365591397849462,
      0.3195876288659794,
      0.8098039215686275
    ]
  },
  "DarkMuted": {
    "_rgb": [
      92,
      56,
      42
    ],
    "_population": 2340,
    "_hsl": [
      0.04666666666666667,
      0.3731343283582089,
      0.2627450980392157
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/BANISHED_S01.js